<template>
  <div
    id="pdf-box"
    class="box"
  >
    <co-loadProcess
      ref="loadProcess"
      @loadingAction="loadingAction"
    />
  </div>
</template>
<script>
import Preview from 'js/preview/preview-sdk.js'
import _$ from 'js/api/getdata.js'
import { getPreviewType, typeIcon, isPC, isMac } from 'js/util/util.js'
import coLoadProcess from 'components/common/loadProcess/index.vue'

export default {
  components: {
    coLoadProcess,
  },
  props: {
    autoload: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default() { return {} },
    },
    isDelivery: {
      type: Boolean,
      default: false,
    },
    previewHandler: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      filePath: '',
      src: '',
      fileInfo: {},
      usePdfjs: false, // 是否使用pdfjs加载
    }
  },
  created() {
    /**
             * 预览整体思路
             * 1. 获取当前文件信息
             * 2. 判断是否走新预览，还是旧预览（只有融合云）
             * 3.
             */
    if (this.autoload) {
      this.startPreview()
    }
  },
  mounted() {
    window.addEventListener('message', this.messageHandler, false)
  },
  destroyed() {
    window.removeEventListener('message', this.messageHandler)
  },
  methods: {
    // 文件切换预处理
    startPreview() {
      this.usePdfjs = false // 重置 是否使用pdfjs加载 变量
      this.loadingRender(this.fileInfo)
    },
    /**
             * 普通文件预览
             */
    async generalView(d) {
      this.loadingRender(d)
      const data = await this.getPreviewUrl(d)
      if (JSON.stringify(data) == '{}') return // 获取预览失败
      this.getPreviewDoc(data)
    },
    /**
             * 外链文件预览
             */
    async deliveryView(d) {
      this.loadingRender(d)
      const data = await this.getDeliveryPreviewUrl(d)
      if (JSON.stringify(data) == '{}') return // 获取预览失败
      this.getPreviewDoc(data)
      return
    },
    /**
             * 存储当前预览文件的信息
             */
    storePreviewInfo() {
      const me = this
      const pdfframe = document.getElementById('pdfframe')
      let obj = {}
      if (pdfframe && pdfframe.contentWindow && pdfframe.contentWindow.PDFViewerApplication) {
        obj = pdfframe.contentWindow.PDFViewerApplication
      }
      me.$store.commit('GET_PREVIEW_INFO', obj)
    },
    /**
             * 初始化pdf
             */
    init(src) {
      const me = this
      me.$nextTick(() => {
        let iframe = document.getElementById('pdfframe')
        function onload() {
          if (!me.usePdfjs) { // 不走pdfjs加载的
            me.$refs.loadProcess.close() // 关闭loading
            me.$emit('iframeloaded')
          }
          const file_type = getPreviewType(me.data)
          if (file_type == 'doc' && me.data.mime_type.indexOf('.xls') === -1) {
            me.storePreviewInfo()
            // 禁用右键
            iframe.contentWindow.document.oncontextmenu = function (e) { return false }
          }
        }
        if (iframe) {
          document.getElementById('pdf-box').removeChild(iframe)
        }
        iframe = document.createElement('iframe')
        iframe.id = 'pdfframe'
        iframe.className = 'box box-iframe'
        iframe.src = src
        document.getElementById('pdf-box').appendChild(iframe)
        iframe.addEventListener('load', onload)
      })
    },
    /**
             * 不同的预览方式，显示不一样的loading
             * 目前 ppt的owa（幻灯片模式）预览是一种形式，其他预览（pdfjs）是另一种形式
             */
    loadingRender(data) {
      let isPPT = false
      if (data && data.mime_type) {
        isPPT = typeIcon(data.mime_type.split('.').pop()) == 'ppt'
      }
      if (this.$store.state.isSideMode && isPPT) {
        this.$refs.loadProcess.pptRender() // 开启icon loading
      } else {
        this.$refs.loadProcess.render() // 开启icon loading
      }
    },
    /**
             * 判断是否是新旧预览
             * @returns status
             */
    async qryUpgradePreview(data) {
      // render loading
      this.loadingRender(data)
      const param = {
        neid: data.neid,
        'X-LENOVO-SESS-ID': data['X-LENOVO-SESS-ID'],
        folder_id: data.delivery_code,
      }
      return _$.getData('qryUpgradePreview', param)
    },
    /**
             * 获取新预览的接口
             * @returns url
             */
    async getPreviewUrl(data) {
      const {
        neid,
        type,
        mime_type: mimeType,
        rev,
        file_extension: fileExtension,
        hash,
        download_url: downloadUrl,
        show_json: showJson,
        aid,
        uid,
        nsid,
        from,
        prefix_neid: prefixNeid,
      } = data
      const param = {
        neid,
        type,
        mime_type: mimeType, // no
        rev,
        file_extension: fileExtension,
        hash,
        wopisrc: downloadUrl,
        show_json: this.getJsonStr(showJson),
        aid, // no
        uid, // no
        nsid,
        from,
        prefix_neid: prefixNeid,
      }
      console.log(param,'param')
      let ret = {}
      try {
        ret = (await _$.getData('newPreviewUrl', param)).data
      } catch (e) {
        this.$refs.loadProcess.close() // 报错时停止loading
        const cfg = {
          forbidden: 'noAccess',
        }
        const error = e.response && e.response.data // 加载失败
        if (error.code && cfg[error.code]) {
          this.$emit('loadFail', cfg[error.code])
        } else {
          this.$emit('loadFail')
        }
        return {}
      }
      return ret
    },
    /**
             * 获取新外链预览的接口
             * @returns url
             */
    async getDeliveryPreviewUrl(data) {
      // 需要调研为空的参数
      const publicKey = localStorage.getItem('public_key')
      this.$jsEncrypt.setPublicKey(publicKey)
      if (data.folder_id.length > 32) {
        data.folder_id = data.folder_id.substring(5, data.folder_id.length)
      }
      const param = {
        folder_id: data.folder_id || '',
        neid: data.neid,
        nsid: data.nsid,
        path_type: data.path_type,
        token: data.token || '',
        password: this.$jsEncrypt.encrypt(data.password) || '',
        approver_op: '',
        show_json: '',
        aid: '',
        uid: '',
      }
      try {
        let ret = (await _$.getData('newDeliveryPreviewUrl', param)).data
        return ret
      } catch (e) {
        this.$refs.loadProcess.close() // 报错时停止loading
        this.$emit('loadFail') // 加载失败
        return {}
      }
    },
    /**
             * 获取旧外链预览的接口
             * @returns url
             */
    async getOldDeliveryPreviewUrl(data) {
      const index = data.path.indexOf('/', 1)
      const relative_path = data.path.substring(index)
      let url = `/delivery/dl_router/preview/${data.deliveryCode}${relative_path}?password=${data.password || ''}&token=${data.token || ''}`
      url = _$.getPrefix(url)
      if (data.mimeType.indexOf('doc') != -1
                || data.mimeType.indexOf('pdf') != -1
                || data.mimeType.indexOf('ppt') != -1) {
        const d = await _$.getUrl(url)
        return d
      }
      return {}
    },
    /**
             * 获取旧预览的接口
             * @returns url
             */
    async getOldPreviewUrl(data) {
      const param = {
        path: data.path,
        root: 'databox', // 旧接口时写死的值
        path_type: data.path_type,
        from: data.param,
        neid: data.neid,
        rev: data.rev,
      }

      let ret = (await _$.getData('oldPreviewUrl', param)).data
      ret = ret.data
      return ret
    },
    /**
             * 处理旧预览不同文件类型的url
             */
    oldPreviewDone(data, metdata) {
      // 目前需要算理的（旧（三类）：dwg doc(stream,owa) 3d 新 音频，视频，图片
      const pubPath = '/v/preveiw'
      let url = ''
      const stat_url = data.previewUrl
      const file_type = getPreviewType(metdata)
      switch (file_type) {
        case 'dwg':
          url = `${pubPath}/static/js/lib/cad/preview_cad_h5.html?${encodeURIComponent(stat_url)}?${this.joinQueryData(data)}`
          break
        case '3d':
          // 3d用web的预览
          url = `/js/module/preview/preview_3d/preview_3d_sview.html?${encodeURIComponent(stat_url)}`
          break
        case 'doc':
          url = stat_url
          break
      }
      this.init(url)
    },
    // 获取预览的文件，通过preview_sdk来看是否生成预览文件
    getPreviewDoc(resData) {
      const vm = this
      // 查看文件是否生成完毕
      if (!this.previewHandler) {
        this.previewHandler = new Preview(vm.previewDone, vm.previewFail)
      }
      // 在文件切换前，把之前文件的请求abort掉
      this.previewHandler.abortAll()
      this.previewHandler.before(resData)
    },
    /**
             * 文件生成成功后要拼接预览的url
             * 此处是生成最终的url入口
             * @returns vvv
             * file_type: "dwg"
             * show_detail: "{}"
             * stat_url: "https://contentqa.vips100.com/v2/preview/stat?access_token=409407aa55640d1e_a66b662e3c7ba3471ab8eba8cb445eb3"
             */
    previewDone(data) {
      this.previewHandler.toggleSetInterval(false)
      this.fileInfo = data
      // 目前需要算理的（旧（三类）：dwg doc(stream,owa) 3d
      const pubPath = '/v/preview'
      let url = ''
      const { stat_url, preview_type, file_type } = data
      switch (file_type) {
        case 'dwg':
          url = `${pubPath}/static/js/lib/cad/preview_cad_h5.html?${encodeURIComponent(stat_url)}`
          break
        case '3d':
          // 3d用web的预览
          url = `/js/module/preview/preview_3d/preview_3d_sview.html?${encodeURIComponent(stat_url)}`
          break
        case 'doc':
          if (preview_type === 'stream') {
            this.usePdfjs = true // pdfjs 加载
            url = `${pubPath}/static/js/lib/pdfjs/2.4.0/web/viewer.html?file=${encodeURIComponent(stat_url)}`
            // 如果有path取出文件名
            const queryData = {
              title: this.data.path && this.data.path.slice(this.data.path.lastIndexOf('/') + 1) || '',
              mimeType: this.data.mime_type,
            }
            url += this.joinQueryData(queryData)
            this.$store.commit('GET_IS_SIDEMODE', true)
            if (this.$refs.loadProcess) {
              this.$refs.loadProcess.render(false) // 转化loading的加载形式，从转圈到进度条
            }
          } else {
            url = stat_url
            this.$store.commit('GET_IS_SIDEMODE', false)
          }
          break
      }
      this.init(url)
      // 这块是不是可以直接赋予iframe的src，不去请求metaData，而是在进来是请求？
    },
    /**
             * 预览文件生成失败后处理后续显示
             */
    previewFail(err) {
      this.$emit('loadFail', 'loadFail')
      this.$refs.loadProcess.close() // 报错时停止loading
    },
    /**
             * loading process中的操作
             * 目前ppt模式在loading中有本地打开（客户端）
             */
    loadingAction(type) {
      this.$emit('loadingAction', type)
    },
    // 拼接query到url
    joinQueryData(qryData) {
      const qryArr = ['']
      for (const key in qryData) {
        if ({}.hasOwnProperty.call(qryData, key)) {
          qryArr.push(`${key}=${encodeURIComponent(qryData[key])}`)
        }
      }
      return qryArr.join('&')
    },
    // 判断是否可以转化成json，可提到公共
    getJsonStr(data) {
      let jsonStr
      try {
        jsonStr = JSON.parse(data)
      } catch (e) {
        jsonStr = data
      } finally {
        return jsonStr
      }
    },
    /**
             * postMessage callback
             */
    messageHandler(e) {
      if (e.data === 'rangeLoading') { // pdfjs 分段加载渲染时，关掉loading
        this.$refs.loadProcess.close()
        this.$emit('iframeloaded')
      }
    },
  },
}
</script>
<style lang="less">
</style>
